import React from 'react';

function Compteur({ counter }) {
 
    return (
        <>
            <div className="compteur">{counter}</div>
        </>
    );
}

export default Compteur;